export default __webpack_public_path__ + "static/media/21.18dce9a0.jpg";